import {createSlice} from "@reduxjs/toolkit";


const activeOrderSlice = createSlice({
    name: "activeOrder",
    initialState: {
        activeOrderData: null
    },
    reducers: {
        setActiveOrderData: (state, action) => {
            state.activeOrderData = action.payload;
        },
    },
});

export default activeOrderSlice;
